module.exports = __webpack_public_path__ + "static/media/parcel_force.f0658fb1.svg";